<script setup>
import {ref} from "vue";
import {actualEvents, archivedEvents} from "@/constants/coPaceEvents";

const showModal = ref(false);
const events = ref([]);
const modalTitle = ref("Upcoming Events");


function open(archived = false) {
    showModal.value = true;
    if (archived) {
        events.value = archivedEvents;
        modalTitle.value = "Archived Events";
    } else {
        events.value = actualEvents;
        modalTitle.value = "Upcoming Events";
    }
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" :title="modalTitle" hide-footer static>
        <ul class="list-events" style="margin-bottom: 20px">
            <li
                v-for="event in events"
                :key="event.name"
            >
                <a
                    v-if="event.url"
                    :href="event.url" target="_blank">
                    <h6 class="heading6">{{ event.name }}</h6>
                </a>

                <h6 v-else class="heading6">{{ event.name }}</h6>
                <time class="list-events__date" datetime="">{{ event.date }}</time>
            </li>
        </ul>
    </b-modal>
</template>

<style scoped>

</style>
